export default __webpack_public_path__ + "static/media/a020-market-2.69242d2a.svg";